// extracted by mini-css-extract-plugin
export default {"back":"OrderModal_back__l69YS","container":"OrderModal_container__7T3oZ","header":"OrderModal_header__hjVjl","main":"OrderModal_main__MyB2D","btn":"OrderModal_btn__BGerE"};